<template>
    <div>
        <div class="advanced-search-location" style="right: 0">
            <el-button v-if="show.generatorBtn"
                       @click="$router.push('/billing/contract/bill/customer/generator?deptType='+filter.deptType)"
                       size="mini">
                <i class="fa fa-file-text-o">
                </i>
                生成客户账单
            </el-button>
            <el-button type="info" plain size="mini" @click="refreshCustomerBillList">
                <i class="fa fa-refresh">
                </i> 刷新
            </el-button>
        </div>
        <el-tabs v-model="activeTabName" @tab-click="jumpToDetail">
            <el-tab-pane label="列表" name="list">
            </el-tab-pane>
            <el-tab-pane label="详情" name="detail" :disabled="!show.canJumpDetail">
            </el-tab-pane>
            <!--            <el-tab-pane label="详情" name="detail" disabled>-->
            <!--            </el-tab-pane>-->
        </el-tabs>
        <el-row class="bottom20" style="overflow: auto">
            <el-table :data="page.records" v-loading="loading" element-loading-text="loading" height="500">
                <el-table-column prop="roomIds" :min-width="150">
                    <template slot="header" slot-scope="scope">
                        数据中心<br>
                        <dictionary-select v-model="pageSearch.search.roomId" :factory-name="'room'"
                                           :params="{type: 'AUTH_SITE'}"
                                           :clearable="true" size="mini"
                        @change="pageSearch.current=1">
                        </dictionary-select>
                    </template>
                    <template slot-scope="scope">
                        <div v-if="scope.row.roomIdsInt != null && scope.row.roomIdsInt.length > 0">
                            <span v-for="(roomId, index) in scope.row.roomIdsInt" :key="index">
                                <dictionary-text :factory-name="'room'" :params="{type: 'ALL'}" :value="roomId">
                                </dictionary-text><br/>
                            </span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="billTypeStr" :min-width="150">
                    <template slot="header" slot-scope="scope">
                        账单类型<br>
                        <el-select v-model="pageSearch.search.billType" size="mini" :clearable="true" placeholder="请选择" @change="pageSearch.current=1">
                            <el-option
                                    v-for="(item,index) in options.customerBill"
                                    :key="index"
                                    :label="item.type"
                                    :value="item.id"
                            >
                            </el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.billTypeStr}}
                    </template>
                </el-table-column>
                <el-table-column prop="customerName" :min-width="200">
                    <template slot="header" slot-scope="scope">
                        客户名称<br>
                        <customer-select v-model="pageSearch.search.customerId" filterable :clearable="true"
                                         size="mini" @change="pageSearch.current=1">
                        </customer-select>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.customerName}}
                    </template>
                </el-table-column>
                <el-table-column prop="contractName" :min-width="260">
                    <template slot="header" slot-scope="scope">
                        合同名称<br>
                        <contract-select v-model="pageSearch.search.contractId"
                                         :customer-id="pageSearch.search.customerId" filterable :clearable="true"
                                         size="mini" @change="pageSearch.current=1">
                        </contract-select>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.contractName}}
                    </template>
                </el-table-column>
                <el-table-column prop="month" :min-width="140">
                    <template slot="header" slot-scope="scope">
                        开始月份<br>
                        <el-date-picker v-model="pageSearch.search.month"
                                        value-format="yyyyMM"
                                        type="month"
                                        placeholder="选择日期"
                                        size="mini"
                         @change="pageSearch.current=1">
                        </el-date-picker>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.month}}
                    </template>
                </el-table-column>
                <el-table-column prop="toMonth" width="120px">
                    <template slot="header" slot-scope="scope">
                        结束月份<br>
                        <div style="height: 40px;"></div>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.toMonth}}
                    </template>
                </el-table-column>
                <el-table-column prop="amount" :min-width="100">
                    <template slot="header" slot-scope="scope">
                        费用<br>
                        <div style="height: 40px;"></div>
                    </template>
                    <template slot-scope="scope">
                        {{formatAmount(scope.row.amount)}}
                    </template>
                </el-table-column>
                <el-table-column prop="statusStr" :min-width="130">
                    <template slot="header" slot-scope="scope">
                        状态<br>
                        <el-select v-model="filter.status" size="mini" :clearable="true"
                                   @change="getBillStatusesByTypeAndStatus">
                            <el-option
                                    v-for="(item,index) in options.operation"
                                    :key="index"
                                    :label="item.status"
                                    :value="item.op"
                            >
                            </el-option>
                        </el-select>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.statusStr}}
                    </template>
                </el-table-column>
                <el-table-column prop="requiredDate" :min-width="150">
                    <template slot="header" slot-scope="scope">
                        要求到账日期<br>
                        <div style="height: 40px"></div>
                    </template>
                    <template slot-scope="scope">
                        {{scope.row.requiredDate}}
                        <template v-if="scope.row.requiredDate==null">-</template>
                    </template>
                </el-table-column>
                <el-table-column prop="serviceLevel" :min-width="300">
                    <template slot="header" slot-scope="scope">
                        操作<br>
                        <div style="height: 40px;"></div>
                    </template>
                    <template slot-scope="scope">
                        <div>
                            <el-button type="warning" plain size="minimum"
                                       @click="customerBillDetail(scope.row.id,'edit',item.op)"
                                       v-for="(item,index) in scope.row.menus" :key="index">{{item.menu}}
                            </el-button>
                            <el-button plain size="minimum" @click="customerBillDetail(scope.row.id,'show')"
                                       v-show="scope.row.view">查看
                            </el-button>
                            <el-button type="danger" plain size="minimum" @click="deleteBill(scope.row.id)"
                                       v-show="scope.row.delete">删除
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageSearch.current"
                    :page-sizes="[10, 25, 50, 100]"
                    :page-size="pageSearch.size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="page.total">
            </el-pagination>
        </el-row>
    </div>
</template>

<script>
    import CustomerSelect from "@/views/billing/customer/component/customer.select"
    import ContractSelect from '@/views/billing/contract/component/contract.select'
    import DictionarySelect from "@/components/common/DictionarySelect"
    import DictionaryText from '@/components/common/DictionaryText'
    import {
        selectCustomerBillPage, //账单分页列表
        selectCustomerBillTypeOptions,  //账单类型选项
        selectCustomerBillStatusOptions, //账单状态选项
        deleteCustomerBillById  //删除账单
    } from '@/api/billing';
    import _ from "lodash";

    export default {
        name: 'billcustomerlist',
        data() {
            return {
                loading: null,
                activeTabName: 'list',
                options: {
                    operation: [],  //操作类型下拉框选项
                    customerBill: []    //账单类型下拉框选项
                },
                pageSearch: {
                    current: 1,
                    size: 10,
                    search: {
                        roomId: null,   //数据中心ID
                        customerId: null,
                        contractId: null,
                        month: null,
                        billStatuses: [],
                        billType: null
                    }
                },
                page: {
                    total: 0,
                    records: []
                },
                //filter: 根据条件过滤页面数据
                filter: {
                    deptType: 1,
                    status: '待处理'
                },
                show: {
                    canJumpDetail: false,  //详情是否可点击
                    firstId: null,
                    generatorBtn: true  //是否显示生成账单按钮
                }
            }
        },
        components: {
            "customer-select": CustomerSelect,
            "contract-select": ContractSelect,
            "dictionary-select": DictionarySelect,
            "dictionary-text": DictionaryText,
        },
        watch: {
            pageSearch: {
                handler: _.debounce(function () {
                    this.getCustomerBillList();
                }, 200),
                immediate: true,
                deep: true
            }
        },
        async mounted() {
            //置空账单生成页面搜索条件
            localStorage.removeItem('billing:contract:bill:customer:generator');
            if (this.$route.params.deptType === undefined) {
                if (this.$route.query.deptType === undefined) {
                    this.filter.deptType = 1
                } else {
                    this.filter.deptType = this.$route.query.deptType;
                    if (this.filter.deptType === "2") {
                        this.show.generatorBtn = false;
                        // getBillStatusesByTypeAndStatus();
                        this.pageSearch.search.billStatuses = [1,2];
                    }else{
                        // getBillStatusesByTypeAndStatus();
                        this.pageSearch.search.billStatuses = [0,1,2];
                    }
                }
            } else {
                this.filter.deptType = this.$route.params.deptType;
            }
            await this.getBillTypeOptions();
            //构建搜索条件
            // let searchCase = sessionStorage.getItem('billing:contract:bill:customer:list');
            // if (null != searchCase) {
            //     console.log("搜索条件:", JSON.stringify(searchCase));
            //     searchCase = JSON.parse(searchCase);
            //     this.pageSearch.search.billType = searchCase.billType;
            //     this.pageSearch.search.contractId = searchCase.contractId;
            //     this.pageSearch.search.customerId = searchCase.customerId;
            //     this.filter.status = searchCase.status;
            //     this.pageSearch.search.month = searchCase.month;
            //     // this.pageSearch.size=searchCase.size;
            //     // this.pageSearch.current=searchCase.current;
            //     if (this.$route.query.deptType !== undefined) {
            //         this.filter.deptType = this.$route.query.deptType;
            //     } else {
            //         this.filter.deptType = searchCase.deptType
            //     }
            //     this.pageSearch.size = searchCase.size;
            //     this.pageSearch.current = searchCase.current;
            //     this.page.total = searchCase.totalCount;
            // }
            await this.getOperationOptions(this.filter.deptType);
        },
        methods: {
            refreshCustomerBillList() {
                this.getCustomerBillList();
            },
            jumpToDetail(tab, event) {
                if (this.activeTabName === 'detail') {
                    this.customerBillDetail(this.show.firstId, 'show');
                }
            },
            /**
             * 跳轉到客戶賬單詳情
             * @param billId 賬單id
             * @param type  edit=編輯 或 show=查看
             * @param op 操作類型
             */
            customerBillDetail: function (billId, type, op) {
                let param = {
                    billType: this.pageSearch.search.billType,
                    contractId: this.pageSearch.search.contractId,
                    customerId: this.pageSearch.search.customerId,
                    status: this.filter.status,
                    month: this.pageSearch.search.month,
                    deptType: this.filter.deptType,
                    size: this.pageSearch.size,
                    current: this.pageSearch.current,
                    totalCount: this.page.total
                };
                sessionStorage.setItem('billing:contract:bill:customer:list', JSON.stringify(param));
                console.log("详情条件:", JSON.stringify(param));
                this.$router.push({
                    name: 'billcustomerdetail',
                    params: {
                        deptType: this.filter.deptType,
                        customerBillDetail: {
                            billId: billId,
                            type: type,
                            op: op,
                            parent: 'billcustomerlist',
                            deptType: this.filter.deptType,
                            title: 'khzd' + this.filter.deptType
                        }
                    }
                });
            },
            handleSizeChange(val) {
                this.pageSearch.size = val;
            },
            handleCurrentChange(val) {
                this.pageSearch.current = val;
            },
            //查询客户账单列表
            async getCustomerBillList(current,size) {
                this.loading = true;
                //根据部门类型 deptType
                if (this.pageSearch.search.roomId==="") {
                    this.pageSearch.search.roomId = null;
                }
                let params = {
                    type: this.filter.deptType,
                    pageNum: current !== undefined ? current : this.pageSearch.current,
                    pageSize: size !== undefined ? size : this.pageSearch.size,
                    billType: this.pageSearch.search.billType,
                    contractId: this.pageSearch.search.contractId,
                    customerId: this.pageSearch.search.customerId,
                    billStatuses: this.pageSearch.search.billStatuses,
                    month: this.pageSearch.search.month,
                    roomId: this.pageSearch.search.roomId
                };
                //加载列表
                try {
                    let result = await selectCustomerBillPage(params);
                    this.page.records = result.data.data.records;
                    this.page.records.forEach(r => {
                        if (r.roomIds != null) {
                            r.roomIdsInt = r.roomIds.split(",").filter(roomId => roomId.trim() !== '')
                                .map(roomId => parseInt(roomId));
                        }
                    })
                    this.page.total = result.data.data.total;
                    this.pageSearch.current = result.data.data.current;
                    this.pageSearch.size = result.data.data.size;
                    this.loading = false;
                    if (this.page.total > 0) {
                        this.show.canJumpDetail = true;
                        this.show.firstId = this.page.records[0].id;
                    }
                } catch (e) {
                    this.loading = false;
                    this.$message.warning("获取数据超时,请稍后重试");
                    console.log(e);
                }
            },
            //删除账单
            async deleteBill(id) {
                this.$confirm('是否要删除该账单?')
                    .then(() => {
                        try {
                            let result = deleteCustomerBillById(id).then(result => {
                                if (result.data.success) {
                                    this.$message.success(result.data.responseMessage)
                                    this.getCustomerBillList();
                                } else {
                                    this.$message.error(result.data.responseMessage)
                                }
                            });
                        } catch (e) {
                            console.log(e);
                        }
                    })
                    .catch(_ => {
                    });
            },
            //获取状态
            async getOperationOptions(type) {
                type = type === undefined ? 1 : type;
                try {
                    let result = await selectCustomerBillStatusOptions(type);
                    this.options.operation = result.data.data;
                } catch (e) {
                    console.log(e);
                }
            },
            //根据部门类型和账单状态设置billStatuses
            getBillStatusesByTypeAndStatus(status) {
                this.pageSearch.current=1;
                // this.pageSearch.size=10;
                //status==待处理
                if (this.$route.query.deptType === "2") {
                    if (status === 9) {
                        status = 8;
                    }
                }
                if (status === null || status === "") {
                    this.pageSearch.search.billStatuses = [];
                } else if (status === 8) {
                    this.pageSearch.search.billStatuses = this.$route.query.deptType === "1" ? [0, 1, 2] : this.$route.query.deptType === "2" ? [1, 2] : [];
                } else {
                    this.pageSearch.search.billStatuses = [status];
                }
                console.log("billstatus", this.pageSearch.search.billStatuses);
            },
            //获取账单类型选项
            async getBillTypeOptions() {
                try {
                    let result = await selectCustomerBillTypeOptions();
                    this.options.customerBill = result.data.data;
                } catch (e) {
                    console.log(e);
                }
            },
            formatAmount(value) {
                return parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
            }
        },
    }
</script>

<style scoped>

</style>
